"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  category: "ΑΝΑΦΟΡΕΣ",
  question: "Πώς μπορώ να υποβάλω μια αναφορά για το ωράριο ή παράπονα;",
  answer: "Η διαδικασία υποβολής αναφοράς απαιτεί προσεκτική σύνταξη και τεκμηρίωση. Οι εξειδικευμένοι νομικοί μας σύμβουλοι μπορούν να σας καθοδηγήσουν βήμα-βήμα, διασφαλίζοντας ότι η αναφορά σας είναι νομικά ορθή και έχει τις μέγιστες πιθανότητες επιτυχίας, προστατεύοντας παράλληλα τα δικαιώματά σας."
}, {
  category: "ΜΕΤΑΘΕΣΕΙΣ",
  question: "Ποια είναι η διαδικασία για τις τακτικές μεταθέσεις και αποσπάσεις;",
  answer: "Οι μεταθέσεις και αποσπάσεις διέπονται από συγκεκριμένους κανονισμούς και μοριοδότηση. Αναλύουμε τα δεδομένα σας, ελέγχουμε τη νομιμότητα των αποφάσεων και σας υποστηρίζουμε σε περίπτωση άδικης μετάθεσης ή ανάγκης για κατ' εξαίρεση τοποθέτηση."
}, {
  category: "ΠΕΙΘΑΡΧΙΚΑ",
  question: "Τι γίνεται σε περίπτωση πειθαρχικών κυρώσεων ή προβλημάτων προαγωγής;",
  answer: "Σε περιπτώσεις πειθαρχικών διώξεων, η άμεση νομική εκπροσώπηση είναι κρίσιμη. Αναλαμβάνουμε την πλήρη υπεράσπισή σας, από την υποβολή απολογίας μέχρι την εκπροσώπηση σε συμβούλια, με στόχο την ακύρωση ή ελαχιστοποίηση των κυρώσεων."
}, {
  category: "ΝΟΜΙΚΑ",
  question: "Πώς μπορώ να ζητήσω χορήγηση εγγράφων ή ασφαλιστικά μέτρα;",
  answer: "Η πρόσβαση στον ατομικό σας φάκελο και σε δημόσια έγγραφα είναι δικαίωμά σας. Αναλαμβάνουμε τη διαδικασία αίτησης χορήγησης εγγράφων και, εφόσον απαιτείται άμεση προστασία, προχωρούμε στην κατάθεση ασφαλιστικών μέτρων."
}, {
  category: "ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ",
  question: "Προσφέρετε εξειδικευμένη συμβουλευτική για συντάξεις ΕΔ & ΣΑ;",
  answer: "Ναι, παρέχουμε πλήρη υποστήριξη σε συνταξιοδοτικά θέματα, υπολογισμό συντάξιμων ετών, αναγνώριση προϋπηρεσίας και καθοδήγηση για τη βέλτιστη χρονική στιγμή αποστρατείας, εξασφαλίζοντας τα μέγιστα δυνατά οφέλη."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="συχνές-ερωτήσεις" className="bg-background py-16 md:py-24 px-6 overflow-hidden">
      <div ref={ref} className={`max-w-3xl mx-auto flex flex-col items-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Badge className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 rounded-full px-4 py-1.5 mb-8 border-none text-xs font-bold tracking-widest uppercase shadow-sm">
          Υποστηριξη
        </Badge>

        <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground text-center mb-6 leading-tight">
          Συχνές Ερωτήσεις
        </h2>

        <p className="text-lg md:text-xl text-foreground text-center mb-12 max-w-2xl leading-relaxed">
          Βρείτε άμεσες απαντήσεις σε καίρια ζητήματα που απασχολούν τα στελέχη των Ενόπλων Δυνάμεων και των Σωμάτων Ασφαλείας σχετικά με την καριέρα και τα δικαιώματά τους.
        </p>

        <div className="w-full text-left bg-card rounded-xl p-4 md:p-8 shadow-sm border border-border/50">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border last:border-0 py-2">
                <AccordionTrigger className="text-foreground hover:no-underline py-4 md:py-6 group">
                  <div className="flex flex-col items-start text-left gap-2">
                    <span className="text-xs font-bold tracking-widest text-muted-foreground uppercase group-hover:text-primary-foreground transition-colors duration-300">
                      {faq.category}
                    </span>
                    <span className="text-lg md:text-xl font-medium leading-snug group-hover:text-primary-foreground transition-colors duration-300">
                      {faq.question}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base md:text-lg pb-6 leading-relaxed pr-8">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12">
          <Button asChild className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 font-medium px-8 py-6 text-lg rounded-md shadow-md transition-all hover:shadow-lg hover:-translate-y-0.5">
            
          </Button>
        </div>
      </div>
    </section>;
}